import { useEffect, useState, useCallback, useMemo } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from './useAuth'

const DEFAULTS = {
  default_alloc_pct: 9,
  default_risk_pct: 7.5,
  default_tranches: 3,
  cost_basis_method: 'fifo',
  timezone: 'America/Chicago',
  default_page: 'last_visited',
  mode: 'live',
  login_webauthn_enabled: false,
}

export function useSettings() {
  const { user } = useAuth()
  const [settings, setSettings] = useState(DEFAULTS)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user) return
    fetchSettings()
  }, [user])

  async function fetchSettings() {
    const { data } = await supabase
      .from('system_settings')
      .select('*')
      .eq('user_id', user.id)
      .single()
    if (data) setSettings({ ...DEFAULTS, ...data })
    else await createDefaultSettings()
    setLoading(false)
  }

  async function createDefaultSettings() {
    const { data } = await supabase
      .from('system_settings')
      .insert({ ...DEFAULTS, user_id: user.id })
      .select()
      .single()
    if (data) setSettings(data)
  }

  const updateSettings = useCallback(async (updates) => {
    const { data, error } = await supabase
      .from('system_settings')
      .update({ ...updates, updated_at: new Date().toISOString() })
      .eq('user_id', user.id)
      .select()
      .single()
    if (!error && data) setSettings(data)
    return { error }
  }, [user?.id])

  return useMemo(
    () => ({ settings, loading, updateSettings }),
    [settings, loading, updateSettings]
  )
}
